import Title from 'antd/es/typography/Title';
import { Flex, Skeleton } from 'antd';
import Button from 'components/Button';
import WidgetCard, { ActivityWidgetProps, WidgetTitle } from '../WidgetCard';

interface LateAgronomistWidgetProps extends ActivityWidgetProps {
  onViewAll: () => void;
  count: number;
}

export const LateAgronomistWidgetSkeleton = () => {
  return (
    <WidgetCard className="activity-widget activity-widget--late-agronomist">
      <Skeleton active title={false} paragraph={{ rows: 1, width: '30%' }} />
      <Flex align="center">
        <Skeleton active title={false} paragraph={{ rows: 1, width: '70%' }} />
        <Skeleton.Button
          active
          style={{ width: '30%', height: 26, borderRadius: 15, marginTop: -10 }}
        />
      </Flex>
    </WidgetCard>
  );
};
const LateAgronomistWidget = ({
  isLoading,
  onViewAll,
  count,
}: LateAgronomistWidgetProps) => {
  if (isLoading) return <LateAgronomistWidgetSkeleton />;

  return (
    <WidgetCard className="activity-widget activity-widget--late-agronomist">
      <WidgetTitle type="normal">Late Agronomists</WidgetTitle>
      <Flex gap={10} justify="space-between" align="center">
        <Title level={3} className="m-0">
          {count}
        </Title>
        {count > 0 && (
          <Button className="activity-widget--btn-view" onClick={onViewAll}>
            View Late
          </Button>
        )}
      </Flex>
    </WidgetCard>
  );
};

export default LateAgronomistWidget;

export type { LateAgronomistWidgetProps };
